define('display/layers/labelsLayer',['leaflet', './tileLayer', './labelsLayerMixinFactory'], function(L, tileLayer, labelsLayerMixinFactory) {
    'use strict';
    var TomTomLabelsLayer;

    function layeraddHandler(event) {
        var map = event.target;
        if (!map.hasLayer(map._ttBaseLayers.vector) && (map._panes.tilePane.childElementCount > 1 ||
            map._panes.overlayPane.childElementCount > 0)) {
            if (!this._container) {
                L.TomTomLayer.prototype.onAdd.call(this, map);
            }
            this.bringToFront();
        }
    }

    TomTomLabelsLayer = L.TomTomLayer.extend({
        options: {},
        name: 'labels',
        initialize: function(options) {
            var labelsOptions = L.extend({}, options, {layer: 'labels', opacity: 0.9});
            L.TomTomLayer.prototype.initialize.call(this, labelsOptions);
        },
        onAdd: function(map) {
            this._layerAddHandler = layeraddHandler.bind(this);
            map.on('layeradd', this._layerAddHandler);
        },
        onRemove: function(map) {
            map.off('layeradd', this._layerAddHandler);
            if (this._container) {
                L.TomTomLayer.prototype.onRemove.call(this, map);
            }
        },
        bringToFront: function() {
            var pane = this._map._panes.overlayPane;
            if (this._container) {
                pane.appendChild(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        _initContainer: function() {
            var tilePane = this._map._panes.overlayPane;
            var className;

            if (!this._container) {
                this._container = L.DomUtil.create('div', 'leaflet-transparent-layer');

                this._updateZIndex();

                if (this._animated) {
                    className = 'leaflet-tile-container';

                    this._bgBuffer = L.DomUtil.create('div', className, this._container);
                    this._tileContainer = L.DomUtil.create('div', className, this._container);

                } else {
                    this._tileContainer = this._container;
                }

                tilePane.appendChild(this._container);

                if (this.options.opacity < 1) {
                    this._updateOpacity();
                }
            }
        },
        updateOptions: function(options) {
            if (options.style) {
                if (!options.layer) {
                    options = L.extend({}, options, {layer: 'labels'});
                }
                L.TomTomLayer.prototype.updateOptions.call(this, options);
            }
        }
    });

    L.TomTomLabelsLayer = TomTomLabelsLayer.extend(labelsLayerMixinFactory('raster'));

    L.tomTomLabelsLayer = function(options) {
        return new L.TomTomLabelsLayer(options);
    };

    return L.tomTomLabelsLayer;
});

